import React from "react";
import IrabPanel from "./IrabPanel";

/**
 * IrabTool — the in-app overlay wrapper around IrabPanel (the working
 * surface shared with the public /irab page). Opened from the sidebar.
 * Escape handling lives in IrabPanel (it knows when the structure modal is
 * open and must consume Escape first).
 */
export default function IrabTool({ onClose, initialText = "", autoAnalyze = false, viewOnly = false }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-start sm:items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm">
      <IrabPanel onClose={onClose} context="overlay" initialText={initialText} autoAnalyze={autoAnalyze} viewOnly={viewOnly} />
    </div>
  );
}
